import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Container, Header, List, Divider } from "semantic-ui-react";
import { fetchAllDepartments } from "../util/FetchDepartmentData";
import Navbar from '../components/common/Navbar';
import Footer from '../components/common/Footer';
import { Link } from 'react-router-dom';
import DepartmentInfoPage from "./DepartmentInfoPage";

const LetterHeader = styled.h2`
  font-family: 'Noto Sans', sans-serif !important;
  font-size: 35px !important;
  font-weight: 500 !important;
  margin: 0;
  padding: 0;
`;

const DepartmentName = styled(List.Item)`
  font-family: 'Noto Sans', sans-serif;
  font-size: 20px;
  font-weight: 600;
  color: #0072CE;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

const TwoColumnWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 150px;
  row-gap: 3rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const PageTitle = styled.h1`
  font-family: 'Noto Sans', sans-serif;
  font-size: 35px;
  font-weight: 700;
  color: black;
  margin-bottom: 2rem;
`;

const PageWrapper = styled.div`
  width: 100%;
  padding-left: 75px;
  padding-right: 75px;
  padding-bottom: 4rem;
  box-sizing: border-box;
`;

const SectionCard = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 30px;
`;

export default function DepartmentPage() {
  const [departments, setDepartments] = useState([]);

  useEffect(() => {
    fetchAllDepartments()
      .then((response) => response.json())  
      .then((data) => {
        console.log("PARSED JSON:", data);
        setDepartments(data);
      })
      .catch((err) => console.error("Error loading departments:", err));
  }, []);

  const grouped = departments.reduce((acc, dept) => {
    const letter = dept.name[0].toUpperCase();
    if (!acc[letter]) acc[letter] = [];
    acc[letter].push(dept);
    return acc;
  }, {});

  const sortedLetters = Object.keys(grouped).sort();

  const leftLetters = sortedLetters.filter((letter) => letter >= 'A' && letter <= 'H');
  const rightLetters = sortedLetters.filter((letter) => letter >= 'I' && letter <= 'Z');

  return (
    <>
      <Navbar />
      <PageWrapper style={{ marginTop: "3rem" }}>
        <PageTitle>List of Departments</PageTitle>
        <TwoColumnWrapper>
          <div>
            {leftLetters.map((letter, index) => (
              <div key={letter}>
                <SectionCard>
                  <LetterHeader>{letter}</LetterHeader>
                  <List relaxed>
                    {grouped[letter]
                      .sort((a, b) => a.name.localeCompare(b.name))
                      .map((dept) => (
                        <DepartmentName key={dept.department_id}>
                          <Link to={`/department/${dept.department_id}?code=${dept.department_code}`} style={{ color: "#0072CE" }}>
                            {dept.name}
                          </Link>
                        </DepartmentName>
                      ))}
                  </List>
                </SectionCard>
                {index !== leftLetters.length - 1 && (
                  <Divider style={{ borderBottom: "2px solid #8F8F8F" }} />
                )}
              </div>
            ))}
          </div>
          <div>
            {rightLetters.map((letter, index) => (
              <div key={letter}>
                <SectionCard>
                  <LetterHeader>{letter}</LetterHeader>
                  <List relaxed>
                    {grouped[letter]
                      .sort((a, b) => a.name.localeCompare(b.name))
                      .map((dept) => (
                        <DepartmentName key={dept.department_id}>
                          <Link to={`/department/${dept.department_id}?code=${dept.department_code}`} style={{ color: "#0072CE" }}>
                            {dept.name}
                          </Link>
                        </DepartmentName>
                      ))}
                  </List>
                </SectionCard>
                {index !== rightLetters.length - 1 && (
                  <Divider style={{ borderBottom: "2px solid #8F8F8F" }} />
                )}
              </div>
            ))}
          </div>
        </TwoColumnWrapper>
      </PageWrapper>
      <Footer />
    </>
  );
}